
import db from '../db'
import firebase from '../fb'
import rtdb from '../rtdb'
import axios from 'axios'
import { firestoreAction, firebaseAction} from 'vuexfire'


const state = {
  btccfa_exchanged: [],
  ethcfa_exchanged: [],
  btcghs_exchanged:[],
  pmcfa_exchanged:[],
  usdtcfa_exchanged:[],
  recent_transactions:[],
  referals:[]
};

const getters = {
  btccfa_exchanged: state => {
    return state.btccfa_exchanged.sort((a, b)=>{return b.created_at-a.created_at});
  },

  pmcfa_exchanged: state => {
    return state.pmcfa_exchanged.sort((a, b)=>{return b.created_at-a.created_at});
  },

  usdtcfa_exchanged: state => {
    return state.usdtcfa_exchanged.sort((a, b)=>{return b.created_at-a.created_at});
  },
  ethcfa_exchanged: state => {
    return state.ethcfa_exchanged
  },
  btcghs_exchanged: state => {
    return state.btcghs_exchanged
  },
  referals: state => {
    return state.referals
  },
  my_btccfa_trades:state => {
    var user = firebase.auth().currentUser;
    return state.btccfa_exchanged.filter(obj => obj.user_id === user.uid)
  },
  my_ethcfa_trades:state => {
    var user = firebase.auth().currentUser;
    return state.btccfa_exchanged.filter(obj => obj.user_id === user.uid)
  },
  my_btcghs_trades:state => {
    var user = firebase.auth().currentUser;
    return state.btccfa_exchanged.filter(obj => obj.user_id === user.uid)
  },
  my_pmcfa_trades:state => {
    var user = firebase.auth().currentUser;
    return state.pmcfa_exchanged.filter(obj => obj.user_id === user.uid)
  },

  my_usdtcfa_trades:state => {
    var user = firebase.auth().currentUser;
    return state.usdtcfa_exchanged.filter(obj => obj.user_id === user.uid)
  },
  recent_transactions:state => {
    var user = firebase.auth().currentUser;
    return state.recent_transactions.filter(obj => obj.user_id === user.uid)
  },
};

const mutations = {
  async transfer_bonus(state, { payload, commit }) {
    let user = firebase.auth().currentUser;
    let userRef = db.collection('users').doc(user.uid);
    let bonus_log_ref = db.collection('bonus_log').doc()
    let amount = payload.amount


    let increment = firebase.firestore.FieldValue.increment(amount);

    let sub_bonus = firebase.firestore.FieldValue.increment(-amount);
    let result = await db.collection('bonus_log').doc()
    let am={
      id:result.id,
      amount:payload.amount,
      user_id:user.uid,
      created_at: firebase.firestore.FieldValue.serverTimestamp()
    }


        try {
          await db.runTransaction(async (tx) => {
            let user_doc = await tx.get(userRef)
            let bonus = Number(user_doc.data().bonus)
            console.log(bonus);

            if (amount<=bonus) {
              //substract bonus amount
              tx.update(userRef, {bonus:sub_bonus})

              //add bonus amount to cfa

              tx.update(userRef, {cfaBalance: increment })

              //set record to db

              tx.set(bonus_log_ref,am)
            }else{
              swal("Solde insuffisan!", "le montant supérieur à la commission!", "error", {
                button: "ok"
              });

              return
            }
            
          });
        
          console.log('Transaction success!');
          swal("succès", "commission transferée avec succès", "success", {
            button: "ok"
          });

        } catch (e) {
          console.log('Transaction failure:', e);
          swal("erreur!", "erreur survenue lors du transfert!", "error", {
              button: "ok"
            });

        }
  },

  async Transfer_partner_bonus(state, { payload, commit }) {
    let user = firebase.auth().currentUser;
          let amount = payload.amount
          let auth_token = payload.auth_token

          let post_data={
            amount:payload.amount,
            user_id:user.uid,
            type: payload.type,
            created_at: ''
          }

          console.log(post_data);

            let baseurl = `${payload.base_url}/payment`
            if (location.hostname === "localhost") {
                  baseurl = 'http://localhost:4000/payment'
                }
            let url = `${baseurl}/partner_bonus_transfer`
            axios.post(url,post_data,auth_token).then(result => {
              console.log(result.data);
              if (result.data == 'success') {
                swal('success', `${amount} transferé avec success`, "success", {button: "ok"});
              }else{
                swal('error', 'erreur veuillez reessayer', "error", {button: "ok"});
              }
            }).catch(error => {
              swal({
                                  title: "Erreur",
                                  text: "erreur survenue veuillez reessayer",
                                  icon: "error",
                                })

            })
    
  },
};

const actions = {
  bind_btccfa_exchanged: firebaseAction(({ bindFirebaseRef }) => {
    // return the promise returned by `bindFirebaseRef`
    return bindFirebaseRef('btccfa_exchanged', rtdb.ref('crypto/btccfa/exchanged').orderByChild('created_at').limitToLast(30))
  }),
  bind_pmcfa_exchanged: firebaseAction(({ bindFirebaseRef }) => {
    // return the promise returned by `bindFirebaseRef`
    return bindFirebaseRef('pmcfa_exchanged', rtdb.ref('electronic/pmcfa/exchanged').orderByChild('created_at').limitToLast(30))
  }),
  bind_usdtcfa_exchanged: firebaseAction(({ bindFirebaseRef }) => {
    // return the promise returned by `bindFirebaseRef`
    return bindFirebaseRef('usdtcfa_exchanged', rtdb.ref('electronic/usdtcfa/exchanged').orderByChild('created_at').limitToLast(30))
  }),
  bind_ethcfa_exchanged: firestoreAction(context => {
    return context.bindFirestoreRef('ethcfa_exchanged', db.collection('crypto').doc('ethcfa').collection('exchanged').orderBy('created_at', 'desc').limit(15));
  }),
  bind_btcghs_exchanged: firestoreAction(context => {
    return context.bindFirestoreRef('btcghs_exchanged', db.collection('crypto').doc('btcghs').collection('exchanged').orderBy('created_at', 'desc').limit(15));
  }),

  bind_recent_transactions: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('recent_transactions', db.collection('recent_transactions').where("user_id", "==", user.uid).orderBy('created_at', 'desc').limit(10));
  }),
  
  bindReferals: firestoreAction(context => {
    var user = firebase.auth().currentUser;
    return context.bindFirestoreRef('referals', db.collection('users').where("sponsor", "==", user.uid));
  }),

  transfer({ commit }, payload) {
    commit('Transfer_partner_bonus', { payload, commit })
  },

};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}